import { createContext, useContext, type Dispatch, type SetStateAction } from "react";

export const ChannelSheetLayout = createContext<{
  footer: HTMLDivElement | null;
  identity: HTMLDivElement | null;
  setTitle: Dispatch<SetStateAction<string | null>>;
  onClose: () => void;
} | null>(null);

export const useChannelSheetLayout = () => useContext(ChannelSheetLayout);
